import React, { useEffect, useRef } from 'react';

/**
 * One AdSense unit. Configured at build time:
 *   REACT_APP_ADSENSE_CLIENT=ca-pub-XXXXXXXXXXXXXXXX
 *   REACT_APP_ADSENSE_SLOT_SIDEBAR=1234567890   (display unit, vertical)
 *   REACT_APP_ADSENSE_SLOT_INLINE=1234567890    (display unit, horizontal)
 * With no client ID nothing renders (no fake placeholder). With a client ID but
 * no slot ID the unit is skipped and Auto ads (enabled in AdSense) place ads instead.
 * The AdSense script itself is loaded once in public/index.html.
 */
const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOTS = {
  sidebar: process.env.REACT_APP_ADSENSE_SLOT_SIDEBAR,
  inline: process.env.REACT_APP_ADSENSE_SLOT_INLINE,
};

export default function AdSlot({ slot, className }) {
  const ref = useRef(null);
  const id = SLOTS[slot];

  useEffect(() => {
    if (!CLIENT || !id || !ref.current || ref.current.dataset.adsbygoogleStatus) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) { /* blocked by an ad blocker */ }
  }, [id]);

  if (!CLIENT || !id) return null;
  return (
    <div className={`ad ${className || ''}`}>
      <span className="ad-label">Advertisement</span>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={CLIENT}
        data-ad-slot={id}
        data-ad-format={slot === 'sidebar' ? 'vertical' : 'horizontal'}
        data-full-width-responsive="true"
      />
    </div>
  );
}
